import classNames from "classnames";
import { FC, HTMLAttributes, ReactNode } from "react";

type LegendItemProps = {
  icon: ReactNode;
  label: ReactNode;
};

const LegendItem: FC<LegendItemProps & { dense?: boolean }> = ({ icon, label, dense }) => {
  if (dense) {
    return (
      <div className="flex items-center gap-1">
        <div className="flex h-3.5 w-3.5 shrink-0 items-center justify-center">{icon}</div>
        <div className="text-font-hover text-[11px] font-medium whitespace-nowrap">{label}</div>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2">
      <div className="flex h-3.5 w-3.5 shrink-0 items-center justify-center">{icon}</div>
      <div className="text-font-hover text-xs font-medium whitespace-nowrap">{label}</div>
    </div>
  );
};

const Legend: FC<{ items: LegendItemProps[]; dense?: boolean } & HTMLAttributes<HTMLDivElement>> = ({
  items,
  className,
  dense,
  ...props
}) => {
  return (
    <div
      className={classNames(
        "font-poppins flex flex-wrap items-center gap-x-6 bg-background-default! gap-y-2 py-3! justify-between px-4!",
        className,
      )}
      {...props}
    >
      {items.map((item, index) => (
        <LegendItem key={index} {...item} dense={dense} />
      ))}
    </div>
  );
};

export default Legend;
